<template>
    <div>
      <van-nav-bar
        :title="$t('app.agent_withdraw_details.title')"
        left-text=""
        left-arrow
        @click-left="$router.push('/member/agency')"

      />
      <van-list 
        :key="$t('app.common.loading')"
        v-model="isLoading" 
        @load="getWithdraw" 
        :finished="finished" 
        :finished-text="$t('app.common.finished')" 
        :loading-text="$t('app.common.loading')"
      >
      <div v-for="(item,index) in withdrawData" :key="index" class="agancyData">
      <van-row>
        <van-col span="7">
            {{ item.remark }}
        </van-col>
        <van-col span="6">
            {{$t("app.agent_withdraw_details.amount")}} {{ item.number }}
        </van-col>
        <van-col span="11" style="text-align:right;">
             {{$t("app.agent_withdraw_details.balance")}} {{ item.balance }}
        </van-col>
      </van-row>
      <van-row>
        <van-col span="7">
            {{ item.statustext }}
        </van-col>
        <van-col span="6"></van-col>
        <van-col span="11" style="text-align:right;color:grey;">
            {{ $getDeviceTime(item.time) }}
        </van-col>
      </van-row>
      <hr>
      </div>
      </van-list>
    </div>
</template>

<script>
    export default {
      name: "AgentWithdrawDetails",
      data(){
        return{
          withdrawData:[],
          isLoading:false,
          finished:false,
          page:1
        }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
        },
        getWithdraw(){
          let that = this;
          let page = that.page;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                nozzle: "agent_withdraw",
                token: sessionStorage.getItem("token"),
                num: 20,
                page: page,
              }
            })
            .then(function (res) {
              let resData = res.data;
              that.isLoading = false;
              if (res.data.code == 1) {
                that.page = page + 1;
                that.withdrawData = that.withdrawData.concat(resData.data);  
                if (resData.data.length < 20){
                   that.finished = true;
                }
              } else if (res.data.code == 0) {
                that.$toast.fail(that.$t(res.data.msg));
              }
            })
            .catch(()=>{
              that.isLoading = false; 
              that.finished = true;
              that.$toast.fail(that.$NoNetworkErrorMsg)
            })
        },
      },
      mounted:function () {
        let that = this;
        that.isLogin();
      }
    }
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.agancyData{
    padding-left: 8px;
    padding-right: 8px;
    font-size: 14px;
    padding-top:5px;
}
</style>



// WEBPACK FOOTER //
// src/components/AgentWithdrawalDetails.vue